import React, { useCallback } from 'react';
import { Button, Overlay, Bubble, Icon } from 'panamera-react-ui';
import { withRouter } from "../../Helpers/withRouter";
import { FormattedMessage as Translation } from 'react-intl';
var css = {
  "conditionModal": "oalp-2XxzO",
  "carImage": "oalp-a2sL3",
  "table": "oalp-10BBG",
  "rowText": "oalp-3nl_S",
  "row": "oalp-3awYX",
  "bubble": "oalp-1axP8",
  "iconContainer": "oalp-2TBhA",
  "heading": "oalp-1zokh",
  "button": "oalp-27zhn"
};
import { CAR_CONDITION } from "../../Constants/carCondition";
import ConditionData from "./ConditionData";
export var ConditionModal = function ConditionModal(_ref) {
  var router = _ref.router;
  var onClose = useCallback(function () {
    router === null || router === void 0 ? void 0 : router.goBack();
  }, [router]);
  return /*#__PURE__*/React.createElement(Overlay, {
    isOpened: true,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: css.conditionModal
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://statics.olx.in/olxin/autos/landingPage/v1/light/CarImage.svg",
    alt: "car condiition",
    className: css.carImage
  }), /*#__PURE__*/React.createElement("div", {
    className: css.heading
  }, /*#__PURE__*/React.createElement(Translation, {
    id: "condition_modal_title"
  })), /*#__PURE__*/React.createElement("div", {
    className: css.table
  }, /*#__PURE__*/React.createElement("div", {
    className: css.row
  }, Object.values(CAR_CONDITION).map(function (condition) {
    return /*#__PURE__*/React.createElement(Bubble, {
      backgroundColor: "background",
      position: "bottom",
      className: css.bubble
    }, /*#__PURE__*/React.createElement(Translation, {
      id: "car_condition_".concat(condition.toLowerCase())
    }));
  })), ConditionData.map(function (rowData) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: css.rowText
    }, /*#__PURE__*/React.createElement(Translation, {
      id: rowData.textId
    })), /*#__PURE__*/React.createElement("div", {
      className: css.row
    }, rowData.icons.map(function (icon) {
      return /*#__PURE__*/React.createElement("div", {
        className: css.iconContainer
      }, /*#__PURE__*/React.createElement(Icon, {
        size: 14,
        icon: icon.name,
        color: icon.color,
        overrideClassName: css.icon
      }));
    })));
  })), /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    className: css.button,
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Translation, {
    id: "got_it"
  }))));
};
export default withRouter( /*#__PURE__*/React.memo(ConditionModal));